import { render, staticRenderFns } from "./block-documents-sign-list-icons.vue?vue&type=template&id=a3ab86f4&scoped=true&lang=pug"
import script from "./block-documents-sign-list-icons.vue?vue&type=script&lang=js"
export * from "./block-documents-sign-list-icons.vue?vue&type=script&lang=js"
import style0 from "./block-documents-sign-list-icons.vue?vue&type=style&index=0&id=a3ab86f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ab86f4",
  null
  
)

export default component.exports